/**
 * Thirteen Orphans — thin wrapper around `game/WinChecker.ts`'s
 * `isThirteenOrphans` (added in T8b), same shape as `sevenPairs.ts`'s use of
 * `isSevenPairs`. Only applies to fully-concealed hands — you cannot call
 * Pung/Chi/Kong and still form this shape — matching
 * `WinChecker.isWinningHand`'s `meldCount === 0` gate for alternate win
 * shapes.
 *
 * `'limit'`-kind patterns short-circuit the whole hand to a fixed cap in
 * `scoring/ScoreCalculator.ts` (T12) — `value` here is NOT load-bearing for
 * that point math, it's purely a display label. `88` is the traditional
 * number this pattern is commonly cited at, same tier as Great Dragons/Winds.
 */

import { isThirteenOrphans } from '../../game/WinChecker.js';
import type { MatchedPattern, ScoringContext } from '../types.js';

const THIRTEEN_ORPHANS_DISPLAY_VALUE = 88;

export function matchThirteenOrphans(context: ScoringContext): MatchedPattern | null {
  if (context.melds.length > 0) return null;
  if (!isThirteenOrphans([...context.concealedTiles, context.winningTile])) return null;

  return { name: 'thirteenOrphans', kind: 'limit', value: THIRTEEN_ORPHANS_DISPLAY_VALUE };
}
